import React from 'react';
import { Panel, Breadcrumb } from 'rsuite';
import Schedule from './Schedule';
import { useTranslation } from 'react-i18next';

const Page = () => {
  const { t } = useTranslation();
  return (
    <Panel
      header={
        <>
          <h3 className="title">{t('Members schedule')}</h3>{' '}
          <Breadcrumb>
            <Breadcrumb.Item href="/">{t('Home')}</Breadcrumb.Item>
            <Breadcrumb.Item active>{t('Members schedule')}</Breadcrumb.Item>
          </Breadcrumb>
        </>
      }
    >
      <Schedule />
    </Panel>
  );
};

export default Page;
